import React, { useState, useEffect } from 'react';

const ZoneContributionsTest = () => {
  const [globalStats, setGlobalStats] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Forcer l'utilisation du token de test
  const testToken = '78|lM7fE6rpnUyn4FX9Iza8tRaNHfg5PVmkA9NE3UCbdbc35f29';

  useEffect(() => {
    // Sauvegarder le token dans localStorage
    sessionStorage.setItem('fsf_auth_token', testToken);
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      
      // Test des statistiques globales
      console.log('🔍 Chargement des statistiques globales...');
      const statsResponse = await fetch(`${process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api'}/zone-dashboard/stats/global`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${testToken}`
        }
      });
      
      if (statsResponse.ok) {
        const stats = await statsResponse.json();
        console.log('✅ Statistiques reçues:', stats);
        setGlobalStats(stats);
      } else {
        console.error('❌ Erreur stats:', await statsResponse.json());
      }

      // Test des membres
      console.log('🔍 Chargement des membres...');
      const membersResponse = await fetch(`${process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api'}/zone-dashboard/members`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${testToken}`
        }
      });
      
      if (membersResponse.ok) {
        const membersData = await membersResponse.json();
        console.log('✅ Membres reçus:', membersData);
        setMembers(membersData.members || []);
      } else {
        console.error('❌ Erreur membres:', await membersResponse.json());
      }

    } catch (error) {
      console.error('❌ Erreur générale:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatAmount = (amount) => {
    if (!amount || amount === 0) return '0';
    const num = parseFloat(amount);
    
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace('.0', '') + 'M';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1).replace('.0', '') + 'K';
    }
    return num.toLocaleString();
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Chargement...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Test Zone Contributions - Cotonou
        </h1>

        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800">Erreur: {error}</p>
          </div>
        )}

        {/* Statistiques */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Total Collecté</h3>
            <p className="text-2xl font-bold text-indigo-600">
              {formatAmount(globalStats?.totalCollectedAllTime)} F CFA
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Cette Année</h3>
            <p className="text-2xl font-bold text-green-600">
              {formatAmount(globalStats?.currentYearTotal)} F CFA
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Taux de Collecte</h3>
            <p className="text-2xl font-bold text-purple-600">
              {globalStats?.collectionRate || 0}%
            </p>
            <p className="text-sm text-gray-500">
              {formatAmount(globalStats?.monthlyCollected || 0)}/{formatAmount(globalStats?.monthlyTarget || 0)} F ce mois
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Membres Cotisants</h3>
            <p className="text-2xl font-bold text-orange-600">
              {globalStats?.contributingMembers || 0}
            </p>
            <p className="text-sm text-gray-500">
              sur {globalStats?.totalMembers || 0} membres
            </p>
          </div>
        </div>

        {/* Liste des membres */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">
              Membres de la Zone ({members.length})
            </h2>
            
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Membre
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Fraternité
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Cotisation Mensuelle
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {members.map((member) => (
                    <tr key={member.id}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="text-sm font-medium text-gray-900">
                            {member.first_name} {member.last_name}
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {member.fraternity}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {formatAmount(member.contribution_monthly)} F CFA
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Debug info */}
        <div className="mt-8 bg-gray-100 p-6 rounded-lg">
          <h3 className="text-lg font-medium mb-4">Debug Info</h3>
          <div className="space-y-2 text-sm">
            <p><strong>Token présent:</strong> {!!sessionStorage.getItem('fsf_auth_token') || localStorage.getItem('fsf_auth_token') ? 'Oui' : 'Non'}</p>
            <p><strong>Zone utilisateur:</strong> Cotonou (test)</p>
            <p><strong>Stats chargées:</strong> {globalStats ? 'Oui' : 'Non'}</p>
            <p><strong>Membres chargés:</strong> {members.length}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZoneContributionsTest;